export enum AircraftDocumentRecipientTypeEnum {
  PreFlightPassengerItinerary = 1,
  PreFlightCrewItinerary = 2,
  FBOTripSheet = 3,
  PreFlightMXRelease = 4,
  HandlingRequest = 5,
  InternationalDocuments = 6,
  PostFlightLogform = 7,
  PostFlightTripSheet = 8
}
